// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"eb332f2a","453":"39077d19"}[chunkId] + ".chunk.js";
};